import { mixed } from 'yup'

export const voidFuncionSchema = mixed<() => void>()
